import axios from 'axios'

export const GOOGLE_MAPS_KEY = 'AIzaSyBX2oZU_cbxDbCatdBtTrHjDJcF1V3jHdw'

const API = axios.create({
  baseURL: 'https://maps.googleapis.com/maps/api/geocode',
  // withCredentials: false,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  },
  params: {
    key: GOOGLE_MAPS_KEY
  }
})

// const API = 'https://maps.googleapis.com/maps/api/geocode/json?address={{address}}'

const cache = {}

export default {
  latLng (addressDetails) {
    return addressDetails.geometry.location
  },
  geometry (addressDetails) {
    return {
      bounds: addressDetails.geometry.bounds,
      viewport: addressDetails.geometry.viewport
    }
  },
  details (address, type) {
    return new Promise((resolve) => {
      if (cache.hasOwnProperty(address)) {
        resolve(cache[address])
      } else {
        API.get(`json?address=${address}`).then(({data}) => {
          if (data.status === 'OK') {
            if (data.results.length) {
              const pertinentData = data.results[0]
              const cached = {
                latLng: this.latLng(pertinentData),
                geometry: this.geometry(pertinentData)
              }
              cache[address] = cached
              resolve(cached)
            } else {
              resolve(null)
            }
          } else {
            resolve(null)
          }
        })
      }
    })
  }
}
